var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DP',{class:{
    'date-picker--26px': !_vm.v2,
  },attrs:{"disabled":_vm.disabled,"lang":_vm.lang,"placeholder":_vm.placeholder,"format":"DD.MM.YYYY"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }